import React from "react";
import { Row, Col, Card } from 'antd';
import { motion } from "motion/react";
import { feUrl } from '../AppConfig';

function Rulebook() {
    return (
      <motion.div initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}} className="content-body">
        <h1>
            LPI Info & Rulebook
        </h1>
      <Row style={{ 'marginTop': '16px' }}>
        <Col span={24}>
          <Card style={{ textAlign: "center" }}>
            <div style={{ textAlign: "left"}}>
              <h1>What is LPI?</h1>
              <p>
                Lega Pauper Italia promotes "smart gaming" via the card game Magic: the Gathering in the "Pauper" format, by utilizing its promotional activities through 
                the work of the Affiliated Leagues, coordinated by a League Manager and related League Staff. 
              </p>
              <p>
                We are also organizers of Paupergeddon, a Pauper open event that represents the culmination and milestone of each Season, where all the italian and 
                international players can play together sharing the passion for this format. 
              </p>
              <p>
                Many Leagues all over Europe trust us with their support, if you are intrested in playing Pauper you can <a href={`${feUrl}/find-league`}>find a league</a> or 
                you can propose the creation of a new one by writing to <a href="mailto:lpauperitalia@gmail.com">lpauperitalia@gmail.com</a>.
              </p>
              <h1>Rulebook & Software</h1>
              <p>
                You can read the updated Rulebook here (last update February 2026): <a href={`${feUrl}/assets/docs/LPI_Rulebook.pdf`}>LPI Rulebook PDF</a> 
              </p>
              <p>
                To promote fair play and help league with the organization of their events we offer many software solutions and the League management portal you are browsing. 
              </p>
              <p>
                Automatic results import guide (last update April 2026):  <a href={`${feUrl}/assets/docs/LPI_ResultImport.pdf`}> Automatic Results Import Guide v0.4</a><br/>
                Decklist gathering tool with Team Trio Decklist Check guide:(last update August 2026): <a href={`${feUrl}/assets/docs/LPI_Decklist_Tool_Guide.pdf`}>Decklist Tool Guide v0.1</a>  
              </p>
              <p>
                For any feedback on our websites/software, or if you have any problem with the data in it write us at <a href="mailto:lpauperitalia@gmail.com">lpauperitalia@gmail.com</a>
              </p>
            </div>
          </Card>
        </Col>
      </Row>
  </motion.div>
    );
}

export default Rulebook;